import { render, staticRenderFns } from "./LeftAside.vue?vue&type=template&id=45f2a43e&scoped=true&"
import script from "./LeftAside.vue?vue&type=script&lang=js&"
export * from "./LeftAside.vue?vue&type=script&lang=js&"
import style0 from "./LeftAside.vue?vue&type=style&index=0&id=45f2a43e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f2a43e",
  null
  
)

export default component.exports